var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ChartContainer',{attrs:{"min-height":"50px","show-classes":"","loading":_vm.loading,"type":_vm.type},on:{"input":_vm.init},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',[_vm._v(_vm._s(_vm.$_t("attribute.student_avg_exam_score"))+" : "+_vm._s(Math.round(_vm.studentAvgExamsScore))+" %")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }